import { themeWorkspace } from "../../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "stats",
    name: "%{BKY_CATSTATS}",
    colour: themeWorkspace.categoryStyles.stats_category.colour,
    imageName: "/toolbox-imgs/bell-curve.svg",
    id: "105",
    contents: [
      {
        kind: "label",
        text: "Stats - loi binomiale",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "binomial_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
          n: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 20,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "binomial_2",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
          n: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 20,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "binomial_3",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
          n: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 20,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "Stats - loi géométrique",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "geometric_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "geometric_2",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "geometric_3",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "Stats - loi de Poisson",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "poisson_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "poisson_2",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "poisson_3",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
        },
      },

      {
        kind: "label",
        text: "Stats - loi uniforme",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "uniform_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          a: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -1,
              },
            },
          },
          b: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "uniform_2",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          a: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -1,
              },
            },
          },
          b: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "uniform_3",
        inputs: {
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          a: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -1,
              },
            },
          },
          b: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },

      {
        kind: "block",
        type: "uniform_4",
        inputs: {
          a: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -1,
              },
            },
          },
          b: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "Stats - loi exponentielle",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "expo_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "expo_2",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "expo_3",
        inputs: {
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "expo_4",
        inputs: {
          lambda: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "Stats - loi normale",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "normal_1",
        inputs: {
          k: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          mean: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          std: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "normal_2",
        inputs: {
          k1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          k2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          mean: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          std: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "normal_3",
        inputs: {
          p: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0.5,
              },
            },
          },
          mean: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          std: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "normal_4",
        inputs: {
          mean: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          std: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
    ],
  };
}
